import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';

export const setFrequenciesFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_FREQUENCIES_FILTER,
    frequenciesFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchFrequencySuccess = (frequencies) => {
  return {
    type: actionTypes.FETCH_FREQUENCY_SUCCESS,
    frequencies: frequencies
  };
};

export const fetchFrequencyByIdSuccess = (frequency) => {
  return {
    type: actionTypes.FETCH_FREQUENCY_BY_ID_SUCCESS,
    frequency: frequency
  };
}

export const requestFrequencyFail = (error) => {
  return {
    type: actionTypes.REQUEST_FREQUENCY_FAIL,
    error: error
  };
};

export const requestFrequencyStart = () => {
  return {
    type: actionTypes.REQUEST_FREQUENCY_START
  };
};

export const deleteFrequencySuccess = (frequency) => {
  return {
    type: actionTypes.DELETE_FREQUENCY_SUCCESS,
    frequency: frequency
  }
}

export const checkDeleteFrequencySuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_FREQUENCY_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateFrequencySuccess = (frequency) => {
  return {
    type: actionTypes.UPDATE_FREQUENCY_SUCCESS,
    frequency: frequency
  }
}

export const postFrequencySuccess = (frequency) => {
  return {
    type: actionTypes.POST_FREQUENCY_SUCCESS,
    frequency: frequency
  }
}

export const fetchFrequency = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestFrequencyStart());
    dispatch(setFrequenciesFilter(page, limit, search, order, orderBy));
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/frequency' + queryParams)
      .then(res => {
        dispatch(fetchFrequencySuccess(res.data));
      })
      .catch(err => {
        dispatch(requestFrequencyFail(err));
      });
  };
};


export const fetchFrequencyById = (id) => {
  return dispatch => {
    dispatch(requestFrequencyStart());
    API.get('/frequency/' + id)
      .then(res => {
        dispatch(fetchFrequencyByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestFrequencyFail(err));
      });
  };
};

export const deleteFrequency = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestFrequencyStart());
      API.put('/frequency/' + index + '/delete')
        .then(res => {
          dispatch(deleteFrequencySuccess(res.data));
          toastr.success(i18n.t('deleteFrequency.toastr'), `${res.data.name} ${i18n.t('deleteFrequency.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestFrequencyFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteFrequency = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestFrequencyStart());
      API.get('/frequency/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteFrequencySuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestFrequencyFail(err));
          resolve('error');
        });
    })
  }
}

export const postFrequency = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestFrequencyStart());
      API.post('/frequency', body)
        .then(res => {
          dispatch(postFrequencySuccess(res.data));
          toastr.success(i18n.t('postFrequencyStr.toastr'), `${res.data.name} ${i18n.t('postFrequencyStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestFrequencyFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postFrequencyStr.toastrError'),i18n.t('postFrequencyStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateFrequency = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestFrequencyStart());
      API.put('/frequency/' + index, body)
        .then(res => {
          dispatch(updateFrequencySuccess(res.data));
          toastr.success(i18n.t('updateFrequencyStr.toastr'), `${res.data.name} ${i18n.t('updateFrequencyStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestFrequencyFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateFrequencyStr.toastrError'), i18n.t('updateFrequencyStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
